/**
 * Платформенный адаптер для shared-кода.
 * Frontend и mobile задают реализацию при старте приложения.
 * Shared не зависит от localStorage/window — только от этого адаптера.
 */

let storageAdapter = null;
let sessionStorageAdapter = null;
let navigateToLoginFn = null;
let getLanguageFn = null;
let shouldRedirectToLoginFn = null;

/**
 * Установить адаптеры (вызывать в index.js / App до импорта store и api).
 * @param {Object} options
 * @param {Object} options.storage - { getItem(key), setItem(key, value), removeItem(key) }
 * @param {Object} options.sessionStorage - то же для сессии
 * @param {Function} options.navigateToLogin - () => void, редирект на логин
 * @param {Function} options.getLanguage - () => string, текущий язык (для Accept-Language)
 * @param {Function} options.shouldRedirectToLogin - () => boolean, нужен ли редирект на логин при 401 (напр. не редиректить на публичных страницах)
 */
export function setPlatform(options = {}) {
  if (options.storage != null) storageAdapter = options.storage;
  if (options.sessionStorage != null) sessionStorageAdapter = options.sessionStorage;
  if (options.navigateToLogin != null) navigateToLoginFn = options.navigateToLogin;
  if (options.getLanguage != null) getLanguageFn = options.getLanguage;
  if (options.shouldRedirectToLogin != null) shouldRedirectToLoginFn = options.shouldRedirectToLogin;
}

export function shouldRedirectToLogin() {
  return typeof shouldRedirectToLoginFn === 'function' ? shouldRedirectToLoginFn() : true;
}

export function getStorage() {
  return storageAdapter;
}

export function getSessionStorage() {
  return sessionStorageAdapter;
}

export function redirectToLogin() {
  if (typeof navigateToLoginFn === 'function') navigateToLoginFn();
}

export function getLanguage() {
  return typeof getLanguageFn === 'function' ? getLanguageFn() : 'en';
}
